/**
 * Feature Flags Configuration
 * Toggle features on/off by changing the boolean values below
 * Can be overridden via URL query parameters for testing
 */

const defaultFlags = {
    /**
     * Enable LinkedIn cap validation in carousel
     * Set to true to enable validation, false to skip
     * Override via URL: ?enableLinkedInCapValidation=true
     */
    enableLinkedInCapValidation: false,
    
    // Add more feature flags here as needed
} as const;

/**
 * Get feature flag value from URL query parameter or default config
 * @param flagName - Name of the feature flag
 * @param defaultValue - Default value if URL param not found
 */
const getFeatureFlagFromUrl = (flagName: string, defaultValue: boolean): boolean => {
    if (typeof window === 'undefined') return defaultValue;
    
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(flagName);
    
    if (paramValue === null) return defaultValue;
    
    return paramValue === 'true' || paramValue === '1';
};

/**
 * Feature flags with URL parameter override support
 */
export const featureFlags = {
    get enableLinkedInCapValidation(): boolean {
        return getFeatureFlagFromUrl('enableLinkedInCapValidation', defaultFlags.enableLinkedInCapValidation);
    },
    
    // Add more feature flags here as needed
};

export type FeatureFlags = typeof featureFlags;
